export class PivotModel {
  constructor(
    public selectColumns: string[] = [],
    public aggregateFunction = '',
    public aggregateColumn = '',
    public pivotColumn = '',
    public pivotValues: string[] = [''],
  ) {}
}

// Structure
// selectColumns should be selected from a list of table columns
// aggregateFunction should be one of 'SUM', 'MIN', 'MAX', 'AVG', 'COUNT'
// aggregateColumn should be selected from list of selected columns
// pivotColumn should be selected from list of selected columns
// pivotValues is an array of user input values

// Rules
// aggregateColumn and pivotColumn should be inside of selected columns
